import { useQuery } from "@tanstack/react-query";
import { fetchEventCities } from "../API/service";
import API_URL from "../API";

export const useEventCities = () => {
    return useQuery({
        queryKey: ["eventCities", API_URL.id_event],
        queryFn: fetchEventCities,
        select: (data) => [...data].sort(
            (a, b) => String(a.time_event).localeCompare(String(b.time_event))
        ),
    });
};
